import Vue from 'vue'
import Vuex from 'vuex'

import rootState from '../index'

Vue.use(Vuex)

export default {
  namespaced: true,
  rootState,
  state: {
    selectedBtn: sessionStorage.getItem('selectedToolBoxBtn') || null,
    // years, rates, ratesDate
    initData: {},
    companys: [],
  },
  getters: {
    selectedBtn: (state) => state.selectedBtn,
    initData: (state) => state.initData,
    companys: (state) => state.companys,
  },
  mutations: {
    setSelectedBtn(state, value) {
      state.selectedBtn = value
      sessionStorage.setItem('selectedToolBoxBtn', value)
    },
    setInitData(state, values) {
      state.initData = values
    },
    setCompanys(state, values) {
      state.companys = values
    },
  },
  actions: {
    async loadInitData({ dispatch }) {
      await Promise.all([dispatch('getInitData'), dispatch('getCompanys')])
    },
    getInitData({ commit }) {
      return Vue.prototype.$axios.get('ptb/init').then((res) => {
        commit('setInitData', res.data)
      })
    },
    getCompanys({ commit }) {
      return Vue.prototype.$axios.get('ptb/logistic/companys').then((res) => {
        commit('setCompanys', res.data)
      })
    },
  },
  modules: {},
}
